 <input class="input"
        type="text"
        [(ngModel)]="autocompleteInput"
        #addresstext style="padding: 8px 8px; border: 1px solid #ccc; width: 100%"
        >